"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridClassicProcessor = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const GridAPProcessor_1 = require("../GridAdjustParams/GridAPProcessor");
const GridTradingUtils_1 = require("./GridTradingUtils");
const Futures_1 = require("./Futures");
const tools_1 = require("../CommonUtils/tools");
class GridClassicProcessor {
    static useUserParams(earnCoin, earnCoinDisplay, trend, top, bottom, count, invest, investPercent, gridType, maxGrids, baseAvailable, quoteAvailable, useAllCoins, triggerPrice, stopLostPrice, takeProfitPrice, currentPrice, symbol, market, tradeAPI, botType, investAction, openPriceLimit, takeProfitDelay, stopLostDelay, movingInfo, updateSignal, maxPerVolume, // gridv4 当前参数支持的最大单网格买卖量
    shareProfitType, closeSellModelProfitStop = TradeAPILib_1.BotOrderCloseModel.TO_QUOTE, //gridv4 自动止盈卖出方式
    closeSellModelLossStop = TradeAPILib_1.BotOrderCloseModel.TO_QUOTE, //gridv4 自动止损卖出方式
    takeProfitType = TradeAPILib_1.GridStopType.price, stopLossType = TradeAPILib_1.GridStopType.price) {
        var _a;
        const earnPrecision = (0, react_1.useMemo)(() => {
            const precision = earnCoin === symbol.base ? symbol.amount : (0, tools_1.getPrecisionCost)(symbol.quote, symbol.precisionCost);
            return precision || 0;
        }, [earnCoin, symbol.amount, symbol.base, symbol.precision]);
        const [fee, feeError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbol, tradeAPI, market);
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid(gridType, top, bottom, count, fee, symbol.precision || 0);
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top, bottom, gridType, fee, (_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, maxGrids);
        const totalAvailable = (0, react_1.useMemo)(() => {
            if (useAllCoins) {
                // 投资的是单网格成交量
                return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(baseAvailable, symbol.amount);
            }
            else {
                if (earnCoin === symbol.quote) {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, (0, tools_1.getPrecisionCost)(symbol.quote, symbol.precisionCost || 0));
                }
                else {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(baseAvailable, symbol.amount);
                }
            }
        }, [baseAvailable, quoteAvailable, symbol, useAllCoins, earnCoin]);
        const minTotalInvest = GridTradingUtils_1.GridTradingUtils.useMinInvest(botType, trend, earnCoin, gridType, top, bottom, count, symbol, market, tradeAPI, currentPrice, triggerPrice, undefined, fee, updateSignal, !useAllCoins, maxGrids);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investAction, invest, investPercent, totalAvailable, earnPrecision, maxPerVolume);
        // 从服务端获取默认ai滑点值
        const { aiSlippage } = Futures_1.GridV4FuturesEditSlippage.useCloseOrderRecommendSlippage({
            base: symbol.base,
            quote: symbol.quote,
            orderType: TradeAPILib_1.ExchangeOrderType.gridV5,
        });
        const tradeLimit = GridTradingUtils_1.GridTradingUtils.useGirdTradeLimit(top, bottom, currentPrice, triggerPrice, symbol, tradeAPI, useAllCoins);
        const minPerVolume = GridTradingUtils_1.GridTradingUtils.useGirdMinPerVolume(tradeLimit);
        const requiredBalance = GridTradingUtils_1.GridTradingUtils.useGridRequireBalance(top, bottom, count, gridType, currentPrice, triggerPrice, parseInvest, tradeLimit, symbol, fee);
        const minInvest = useAllCoins ? minPerVolume || "" : minTotalInvest;
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: totalAvailable,
            };
            if (parseInvest) {
                if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(totalAvailable))) {
                    state.state = "large";
                }
                else if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                    state.state = "small";
                }
            }
            return state;
        }, [parseInvest, minInvest, totalAvailable]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, count);
            if (useAllCoins) {
                if (!Number(parseInvest)) {
                    emptys.push("trade_grid_per_volume");
                }
            }
            else {
                if (!Number(parseInvest)) {
                    emptys.push("trading_total_investment");
                }
            }
            return emptys;
        }, [top, bottom, count, parseInvest, useAllCoins]);
        return {
            botType,
            top,
            bottom,
            count,
            invest: parseInvest,
            investPercent: parseInvestPercent,
            gridType,
            baseAvailable,
            quoteAvailable,
            earnCoin,
            trend,
            useAllCoins,
            triggerPrice,
            stopLostPrice,
            takeProfitPrice,
            currentPrice,
            symbol,
            openPriceLimit,
            earnCoinDisplay,
            fee,
            calculateFee: fee,
            feeError,
            emptyErrors,
            investState,
            minInvest,
            profitPerGrid,
            totalAvailable,
            earnPrecision,
            needBase: (requiredBalance === null || requiredBalance === void 0 ? void 0 : requiredBalance.needBase) || "",
            needQuote: (requiredBalance === null || requiredBalance === void 0 ? void 0 : requiredBalance.needQuote) || "",
            maxGrids: maxGrids,
            realMaxGrids: calcuGridsMax,
            takeProfitDelay,
            stopLostDelay,
            movingIndicatorType: movingInfo === null || movingInfo === void 0 ? void 0 : movingInfo.movingIndicatorType,
            movingIndicatorInterval: movingInfo === null || movingInfo === void 0 ? void 0 : movingInfo.movingIndicatorInterval,
            movingIndicatorParam: movingInfo === null || movingInfo === void 0 ? void 0 : movingInfo.movingIndicatorParam,
            movingTrailingUpParam: movingInfo === null || movingInfo === void 0 ? void 0 : movingInfo.movingTrailingUpParam,
            closeSellModelProfitStop,
            closeSellModelLossStop,
            tpStopType: takeProfitType,
            slStopType: stopLossType,
            aiSlippage,
            shareProfitType,
        };
    }
    static getCreateOrderRequest(params, $st) {
        const request = GridTradingUtils_1.GridTradingUtils.checkCommonParamsByLocal(params, $st);
        if (params.useAllCoins) {
            if (new trade_utils_lib_1.SafeDecimal(params.needBase).greaterThan(params.baseAvailable)) {
                throw $st("trade_error_balance_not_enough");
            }
            if (new trade_utils_lib_1.SafeDecimal(params.needQuote).greaterThan(params.quoteAvailable)) {
                throw $st("trade_error_balance_not_enough");
            }
            request.per_volume = params.invest;
            request.base_total_investment = params.needBase;
            request.quote_total_investment = params.needQuote;
        }
        if (!new trade_utils_lib_1.SafeDecimal(params.takeProfitDelay).equals(0)) {
            request.profit_stop_delay = params.takeProfitDelay;
        }
        if (!new trade_utils_lib_1.SafeDecimal(params.stopLostDelay).equals(0)) {
            request.loss_stop_delay = params.stopLostDelay;
        }
        if (!new trade_utils_lib_1.SafeDecimal(params.movingTrailingUpParam).equals(0)) {
            request.moving_indicator_type = params.movingIndicatorType;
            request.moving_indicator_interval = params.movingIndicatorInterval;
            request.moving_indicator_param = params.movingIndicatorParam;
            request.moving_trailing_up_param = params.movingTrailingUpParam;
        }
        return request;
    }
    // 计算开网格单base,quote资产数量
    static calculateOpenPositionCoinValue(params) {
        const openPrice = params.triggerPrice || params.currentPrice;
        let perVolume = params.invest;
        if (!params.useAllCoins) {
            const perVolumeNum = GridTradingUtils_1.GridTradingUtils.getPerGridValume(params.top, params.bottom, params.count, "0", params.invest, openPrice, params.gridType, params.trend);
            perVolume = new trade_utils_lib_1.SafeDecimal(perVolumeNum).toString();
        }
        // 对结果来说trade limit影响很小, 没必要发起网络请求
        const fakeTradeLimit = {
            amount: {
                min: null,
                max: null,
            },
            cost: {
                min: null,
                max: null,
            },
        };
        return GridTradingUtils_1.GridTradingUtils.calculateGridRequireBalance(params.top, params.bottom, params.count, params.gridType, openPrice, perVolume, fakeTradeLimit, params.symbol, params.fee);
    }
    // 计算base所占开网格单资产的百分比
    static calculateBasePercentage(params) {
        const needBalance = this.calculateOpenPositionCoinValue(params);
        // base的价值
        const openPrice = params.triggerPrice || params.currentPrice;
        const baseValue = new trade_utils_lib_1.SafeDecimal(needBalance === null || needBalance === void 0 ? void 0 : needBalance.needBase).mul(new trade_utils_lib_1.SafeDecimal(openPrice));
        const percentage = baseValue.div(baseValue.add(new trade_utils_lib_1.SafeDecimal(needBalance === null || needBalance === void 0 ? void 0 : needBalance.needQuote)));
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(percentage, 4);
    }
    static queryGridV3MaxCount(vipLevel, symbol, tradeConfig, orderType) {
        const remoteConfig = tradeConfig === null || tradeConfig === void 0 ? void 0 : tradeConfig.trade_grid_max_count_config;
        if (remoteConfig && symbol) {
            const maxCount = remoteConfig[symbol];
            if (maxCount) {
                return Number(maxCount);
            }
        }
        if (orderType === TradeAPILib_1.ExchangeOrderType.gridV5) {
            switch (vipLevel) {
                case "mm":
                    return GridAPProcessor_1.GIRDV3SUPPORTMAXABILITY;
                default:
                    return 500;
            }
        }
        else {
            switch (vipLevel) {
                case "mm":
                    return GridAPProcessor_1.GIRDV3SUPPORTMAXABILITY;
                case "none":
                case "vip0":
                    return 250;
                default:
                    return 500;
            }
        }
    }
}
exports.GridClassicProcessor = GridClassicProcessor;
